import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=260e4a9c"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260e4a9c')) {
      api.createRecord('260e4a9c', component.options)
    } else {
      api.reload('260e4a9c', component.options)
    }
    module.hot.accept("./MessageView.vue?vue&type=template&id=260e4a9c", function () {
      api.rerender('260e4a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/feedback/MessageView.vue"
export default component.exports